/* eslint-disable jsx-a11y/anchor-is-valid */
import { getConfig } from '../../../_metronic/helpers/LanguageHelper'
import axios from 'axios'
import * as authHelper from '../../modules/auth/core/AuthHelpers'
import {
  ChartsWidget1Dto,
  ChartsWidgetLineDto,
  CardsWidget17Dto,
  TablesWidget5Dto,
  TablesWidget5ItemDto,
  ListsWidget6Dto,
  WordCloudDto,
  TablesWidget14Dto,
  TablesWidget14ItemDto,
  ChartsWidgetTreeDto,
  AttributesDto,
  ChartsWidgetBubbleDto,
  TablesWidget15Dto,
  TablesWidget15ItemDto,
} from '../../../_metronic/partials/widgets'
import { getChannelImageUrl, getHappinessScore, getMonthName } from '../../../_metronic/helpers/utility'
import { toast } from 'react-toastify'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { CardsWidget18Dto, CardsWidget18Dto_CompetitorVolume } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget18'
import { ChartsWidgetWorldMapDto, ChartsWidgetLanguageBarDto } from '../../../_metronic/partials/widgets/charts/ChartsWidgetWorldMap'
const API_URL = process.env.REACT_APP_API_URL
const API_FILE_URL = process.env.REACT_APP_API_URL?.substring(0, process.env.REACT_APP_API_URL.length - 4)

export type GeoLanguageCountryCountItem = {
  code: string
  count: number
}

export type ReviewDocumentLanguageCountryFilterOptions = {
  isEnabled: boolean
  languages: GeoLanguageCountryCountItem[]
  countries: GeoLanguageCountryCountItem[]
}

function getSentimentTableResult(response: any): { itemList: any[]; totalCount: number; totalRate: number } | null {
  const result = response?.data?.result
  if (!result) {
    return null
  }
  const itemList = result.reviewDocumentSentimentChannelCountItemDtoList
  return {
    itemList: Array.isArray(itemList) ? itemList : [],
    totalCount: result.totalCount ?? 0,
    totalRate: result.totalRate ?? 0,
  }
}

export function GetReviewDocumentLanguageCountryFilterOptions(listType: 'review' | 'restriction' = 'review'): Promise<ReviewDocumentLanguageCountryFilterOptions> {
  return axios
    .get(`${API_URL}/ReviewDocuments/GetReviewDocumentLanguageCountryFilterOptions`, {
      params: { listType },
    })
    .then((response) => {
      const result = response?.data?.result || {}
      const mapItems = (items: any[]): GeoLanguageCountryCountItem[] =>
        Array.isArray(items)
          ? items
              .map((item) => ({
                code: (item?.code ?? item?.Code ?? '').toString(),
                count: Number(item?.count ?? item?.Count ?? 0),
              }))
              .filter((item) => item.code)
          : []

      return {
        isEnabled: !!result.isEnabled,
        languages: mapItems(result.languages),
        countries: mapItems(result.countries),
      }
    })
}

export function GetCompetitorNames(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetCompetitorNameList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return item === null ? LanguageHelp('We') : item; }))
}
export function GetReviewTagsForSelect2(isGetSubclasses = false): Promise<any | undefined> {
  const auth = authHelper.getAuth()

  return axios({
    method: 'get',
    url: `${API_URL}/Dashboard/GetReviewTagBasicsList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      isGetSubclasses: isGetSubclasses
    }
  })
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return [];
      }
    })
    .then((response: [any]) => response.map(function (item) { return { label: item.name, value: item.id, isParent: item.isParent }; }))
}
export function GetReviewSubjectGroupsForSelect2(isGetSubclasses = false): Promise<any | undefined> {
  const auth = authHelper.getAuth()

  return axios({
    method: 'get',
    url: `${API_URL}/Dashboard/GetReviewSubjectGroupBasicsList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      isGetSubclasses: isGetSubclasses
    }
  })
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return [];
      }
    })
    .then((response: [any]) => response.map(function (item) { return { label: item.name, value: item.id, isParent: item.isParent }; }))
}
export function GetReviewSubjectsForSelect2(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewSubjectBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return { label: item.name, value: item.id }; }))
}
export function GetReviewSubjects(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewSubjectBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return item.name; }))
}
export function GetReviewTags(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewTagBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return item.name; }))
}

export function GetReviewChannels(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewChannelBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return { key: item.id, value: item.label, type: item.channelType }; }))
}

// Server should return AuthModel
export function GetCompetitionVolumeDistribution(sourceType = "", date = "", subject = "", tag = "", channelType = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  // console.log('auth', auth)
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetVolumeDistribution`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject,
      'tag': tag,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsed: CardsWidget18Dto = {
      allCount: response.data.result.data.totalCount as number,
      competitorVolumes: []
    };
    response.data.result.data.competitorVolumeList.forEach((element: any) => {
      if (element !== undefined) {
        var competitorVolumeParsed: CardsWidget18Dto_CompetitorVolume = {
          competitorName: element.competitorName as string,
          count: element.count as number,
        }
        responseParsed.competitorVolumes.push(competitorVolumeParsed)
      }
    });
    return responseParsed;
  });
}

// Server should return AuthModel
export function GetSentimentDistribution(sourceType = "", date = "", subject = "", tag = "", channelType = "", competitorName = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  // console.log('auth', auth)
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetSentimentDistribution`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject,
      'tag': tag,
      'competitorName': competitorName,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsed: CardsWidget17Dto = {
      firstCount: response.data.result.positiveCount as number,
      secondCount: response.data.result.negativeCount as number,
      thirdCount: response.data.result.neutralCount as number,
      firstRate: response.data.result.positiveRate as number,
      secondRate: response.data.result.negativeRate as number,
      thirdRate: response.data.result.neutralRate as number,
      allCount: response.data.result.sentimentCount as number,
      rate: response.data.result.increaseRate as number
    };
    return responseParsed;
  });
}

export function DownloadTestSentimentRateByChannels() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestSentimentRateByChannels`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentRateByChannels(sourceType = "", date = "", subject = "", tag = "", channelType = "", competitorName = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestSentimentRateByChannels`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'channelType': channelType,
      'competitorName': competitorName,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = new TablesWidget5Dto
    responseParsedList.items.shift()
    responseParsedList.totalCount = response.data.result.totalCount
    responseParsedList.totalRate = response.data.result.totalRate
    response.data.result.reviewDocumentSentimentChannelCountItemDto.forEach((element: any) => {
      if (element !== undefined) {
        var responseParsed: TablesWidget5ItemDto = {
          id: element.id as string,
          label: element.channelName as string,
          type: element.channelType as number,
          isCompetitor: element.isCompetitor as boolean,
          firstCount: element.totalCount as number,
          secondCount: element.positiveCount as number,
          thirdCount: element.negativeCount as number,
          fourthCount: element.neutralCount as number,
          firstRate: element.totalRate as number,
          secondRate: element.positiveRate as number,
          thirdRate: element.negativeRate as number,
          fourthRate: element.neutralRate as number,
          image: "",
          url: "/apps/artificial-intelligence/overview?filter_channel=" + element.id
        }
        responseParsed.image = getChannelImageUrl(responseParsed.type);
        if (responseParsed.type == 4) {
          responseParsed.label = responseParsed.label.replace("Facebook", "")
          responseParsed.label = responseParsed.label.replace("facebook", "")
        }
        responseParsedList.items.push(responseParsed)
      }
    });
    return responseParsedList
  });
}

export function GetTestSentimentCountByCompetitors(sourceType = "", date = "", subject = "", tag = "", channelType = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndCompetitor`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: element.competitor as string,
            subject: '',
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndCompetitor() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndCompetitor`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByPlatforms(sourceType = "", date = "", subject = "", tag = "", competitor = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndPlatform`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'competitor': competitor != null ? competitor.replaceAll("asc38", "&") : null,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: LanguageHelp(element.platform),
            subject: '',
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function GetTestSentimentCountByCountries(sourceType = "", date = "", subject = "", tag = "", competitor = "", channelType = "", analysisLevel = "", filterLanguage = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountByCountry`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'competitor': competitor != null ? competitor.replaceAll("asc38", "&") : null,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
    }
  }).then(response => {
    const responseParsedList: ChartsWidgetWorldMapDto[] = []

    if (response.data.result?.length) {
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          responseParsedList.push({
            country: element.country as string,
            totalCount: element.totalCount as number,
            positiveCount: element.positiveCount as number,
            negativeCount: element.negativeCount as number,
            neutralCount: element.neutralCount as number,
          })
        }
      })
    }

    return responseParsedList
  })
}

export function GetTestSentimentCountByLanguages(sourceType = "", date = "", subject = "", tag = "", competitor = "", channelType = "", analysisLevel = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountByLanguage`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'competitor': competitor != null ? competitor.replaceAll("asc38", "&") : null,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    const responseParsedList: ChartsWidgetLanguageBarDto[] = []

    if (response.data.result?.length) {
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          responseParsedList.push({
            language: element.language as string,
            totalCount: element.totalCount as number,
            positiveCount: element.positiveCount as number,
            negativeCount: element.negativeCount as number,
            neutralCount: element.neutralCount as number,
          })
        }
      })
    }

    return responseParsedList
  })
}

export function DownloadTestCountBySentimentAndPlatform() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndPlatform`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByCompetitorsAndSubjects(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndCompetitorAndSubject`,
    timeout: 180000,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidgetBubbleDto]
    responseParsedList[0].label = "-";

    if (response.data.result !== null && response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidgetBubbleDto = {
            label: element.competitor as string,
            subject: element.subject as string,
            firstCount: element.positiveCount as number,
            secondCount: element.negativeCount as number,
            thirdCount: element.neutralCount as number,
            totalCount: element.totalCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndCompetitorAndSubject() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndCompetitorAndSubject`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByMonths(sourceType = "", subject = "", tag = "", channelType = "", competitorName = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndMonth`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'competitorName': competitorName,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: getMonthName(element.month as number),
            subject: '',
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndMonth() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndMonth`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByDays(sourceType = "", subject = "", tag = "", channelType = "", competitorName = "", analysisLevel = "", filterLanguage = "", filterCountry = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndDay`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'sourceType': sourceType,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'tag': tag != null ? tag.replaceAll("asc38", "&") : null,
      'competitorName': competitorName,
      'channelType': channelType,
      'analysisLevel': analysisLevel,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidgetLineDto]
    responseParsedList[0].label = 0;

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidgetLineDto = {
            label: element.day,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndDay() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndDay`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetNotifications() {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetNotificationListForAgent`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    }
  }).then(response => {
    var responseParsedList = [new ListsWidget6Dto]
    responseParsedList.shift();
    response.data.result.forEach((element: any) => {
      if (element !== undefined) {
        var responseParsed: ListsWidget6Dto = {
          label: element.notificationText,
          url: element.notificationUrl,
          className: element.notificationColor === "1" ? "d-flex align-items-center bg-light-danger rounded p-4 mb-3" : (element.notificationColor === "2" ? "d-flex align-items-center bg-light-warning rounded p-4 mb-3" : "d-flex align-items-center bg-light-success rounded p-4 mb-3"),
        }
        responseParsedList.push(responseParsed)
      }
    });
    return responseParsedList
  });
}

export function GetTokenListForWordCloudList(sourceType = "", date = "") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetTokenListForWordCloud`,
    data: {
      'sourceType': sourceType,
      'size': 50,
      'date': date,
    }
  }).then(response => {
    var responseParsedList = [new WordCloudDto]
    responseParsedList[0].text = "-";

    if (response.data.result.data !== null && response.data.result.data.length > 0) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: WordCloudDto = {
            text: element.text,
            value: element.totalCount,
            positiveCount: element.positiveCount,
            negativeCount: element.negativeCount,
            neutralCount: element.neutralCount,
            sentimentRate: element.sentimentRate,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }

    return responseParsedList
  });
}

export function GetTokenForTableList(sourceType = "", date = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTokenCountList`,
    params: {
      'sourceType': sourceType,
      'date': date
    }
  }).then(response => {
    var responseParsedList = new TablesWidget14Dto
    responseParsedList.items[0].label = "-";

    if (response.data.result.tokenCountItemDtoList !== null
      && response.data.result.tokenCountItemDtoList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = response.data.result.totalCount
      responseParsedList.totalRate = response.data.result.totalRate
      response.data.result.tokenCountItemDtoList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget14ItemDto = {
            id: element.id as string,
            label: element.tokenText as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            fifthCount: 0 as number,
            sixthCount: 0 as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
            fifthRate: 1 as number,
            sixthRate: 1 as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTokensForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTokenList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetSubjectSentimentListForWordCloudList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetSubjectSentimentListForWordCloud`,
    data: {
      'sourceType': sourceType,
      'size': 50,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new WordCloudDto]
    responseParsedList[0].text = "-";

    if (response.data.result.data !== null && response.data.result.data.length > 0) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: WordCloudDto = {
            text: element.text,
            value: element.totalCount,
            positiveCount: element.positiveCount,
            negativeCount: element.negativeCount,
            neutralCount: element.neutralCount,
            sentimentRate: element.sentimentRate,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }

    return responseParsedList
  });
}

export function GetSubjectSentimentForTableList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetSubjectSentimentListForTable`,
    params: {
      'sourceType': sourceType,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = new TablesWidget14Dto
    responseParsedList.items[0].label = "-";

    const tableResult = getSentimentTableResult(response)
    if (tableResult && tableResult.itemList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = tableResult.totalCount
      responseParsedList.totalRate = tableResult.totalRate
      tableResult.itemList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget14ItemDto = {
            id: element.id as string,
            label: element.subject as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            fifthCount: 0 as number,
            sixthCount: 0 as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
            fifthRate: 1 as number,
            sixthRate: 1 as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    } else {
      responseParsedList.totalCount = 0
    }
    return responseParsedList
  }).catch(() => {
    const responseParsedList = new TablesWidget14Dto()
    responseParsedList.totalCount = 0
    return responseParsedList
  });
}

export function DownloadSubjectSentimentsForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadSubjectSentimentList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

function resolveSentimentTableTotalCount(tableResult: { itemList: any[]; totalCount: number }): number {
  if (tableResult.totalCount > 0) {
    return tableResult.totalCount
  }
  const rowsTotal = tableResult.itemList.reduce((sum, element) => sum + (element?.totalCount || 0), 0)
  return rowsTotal > 0 ? rowsTotal : tableResult.itemList.length
}

export function GetSubjectSentimentCompetitionForTableList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetSubjectSentimentCompetitionListForTable`,
    timeout: 180000,
    params: {
      'sourceType': sourceType,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = new TablesWidget15Dto
    responseParsedList.items[0].label = "-";

    const tableResult = getSentimentTableResult(response)
    if (tableResult && tableResult.itemList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = resolveSentimentTableTotalCount(tableResult)
      responseParsedList.totalRate = tableResult.totalRate
      tableResult.itemList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget15ItemDto = {
            id: element.id as string,
            label: (element.name || element.subject) as string,
            competitor: element.competitorName as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            fifthCount: 0 as number,
            sixthCount: 0 as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
            fifthRate: 1 as number,
            sixthRate: 1 as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    } else {
      responseParsedList.totalCount = 0
    }
    return responseParsedList
  }).catch(() => {
    const responseParsedList = new TablesWidget15Dto()
    responseParsedList.totalCount = 0
    return responseParsedList
  });
}

export function DownloadSubjectSentimentCompetitionsForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadSubjectSentimentCompetitionList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetSubjectGroupSentimentCompetitionForTableList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetSubjectGroupSentimentCompetitionListForTable`,
    params: {
      'sourceType': sourceType,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = new TablesWidget15Dto
    responseParsedList.items[0].label = "-";

    const tableResult = getSentimentTableResult(response)
    if (tableResult && tableResult.itemList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = tableResult.totalCount
      responseParsedList.totalRate = tableResult.totalRate
      tableResult.itemList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget15ItemDto = {
            id: element.id as string,
            label: element.name as string,
            competitor: element.competitorName as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            fifthCount: 0 as number,
            sixthCount: 0 as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
            fifthRate: 1 as number,
            sixthRate: 1 as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    } else {
      responseParsedList.totalCount = 0
    }
    return responseParsedList
  }).catch(() => {
    const responseParsedList = new TablesWidget15Dto()
    responseParsedList.totalCount = 0
    return responseParsedList
  });
}

export function DownloadSubjectGroupSentimentCompetitionsForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadSubjectGroupSentimentCompetitionList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetHashtagListForWordCloudList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetHashtagListForWordCloud`,
    data: {
      'sourceType': sourceType,
      'size': 50,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = [new WordCloudDto]
    responseParsedList[0].text = "-";

    if (response.data.result.data !== null && response.data.result.data.length > 0) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: WordCloudDto = {
            text: element.hashtag,
            value: element.totalCount,
            positiveCount: element.totalCount,
            negativeCount: 0,
            neutralCount: 0,
            sentimentRate: 1,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }

    return responseParsedList
  });
}

export function GetHashtagForTableList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5", filterLanguage = "", filterCountry = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetHashtagCountList`,
    params: {
      'sourceType': sourceType,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
      'filterLanguage': filterLanguage,
      'filterCountry': filterCountry,
    }
  }).then(response => {
    var responseParsedList = new TablesWidget14Dto
    responseParsedList.items[0].label = "-";

    const tableResult = getSentimentTableResult(response)
    if (tableResult && tableResult.itemList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = tableResult.totalCount
      responseParsedList.totalRate = tableResult.totalRate
      tableResult.itemList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget14ItemDto = {
            id: element.id as string,
            label: element.hashtag as string,
            firstCount: element.totalCount as number,
            secondCount: element.viewCount as number,
            thirdCount: element.likeCount as number,
            fourthCount: element.dislikeCount as number,
            fifthCount: element.commentCount as number,
            sixthCount: element.shareCount as number,
            firstRate: element.totalRate as number,
            secondRate: element.viewRate as number,
            thirdRate: element.likeRate as number,
            fourthRate: element.dislikeRate as number,
            fifthRate: element.commentRate as number,
            sixthRate: element.shareRate as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    } else {
      responseParsedList.totalCount = 0
    }
    return responseParsedList
  }).catch(() => {
    const responseParsedList = new TablesWidget14Dto()
    responseParsedList.totalCount = 0
    return responseParsedList
  });
}

export function DownloadHashtagsForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadHashtagList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetReviewSubjectTreeList(sourceType = "", date = "", competitorName = "", channelType = "", subject = "", tag = "", minCount = "5") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetReviewSubjectTreeList`,
    data: {
      'sourceType': sourceType,
      'date': date,
      'competitorName': competitorName,
      'channelType': channelType,
      'subject': subject,
      'tag': tag,
      'minCount': minCount,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidgetTreeDto]

    if (response.data.result.data !== null) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var attributes: AttributesDto = {
            totalCount: element.attributes.totalCount,
            positiveCount: element.attributes.positiveCount,
            negativeCount: element.attributes.negativeCount,
            neutralCount: element.attributes.neutralCount,
            happinessScore: getHappinessScore(element.attributes.positiveCount, element.attributes.negativeCount),
          }

          var responseParsed: ChartsWidgetTreeDto = {
            id: element.id,
            name: element.name,
            attributes: {
              totalCount: element.attributes.totalCount,
              positiveCount: element.attributes.positiveCount,
              negativeCount: element.attributes.negativeCount,
              neutralCount: element.attributes.neutralCount,
              happinessScore: element.attributes.happinessScore,
            } as AttributesDto,
            children: element.children,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}